/**
 * @param {*} value
 * @return {value is Set}
 */
export function isSet(value) {
  return value instanceof Set;
}
